import { ErknmPlanStatusesEnum } from 'APIPackage/PlanListModule/enums/ErknmPlanStatusesEnum';
import { ErknmPlanStatusTitlesEnum } from 'APIPackage/PlanListModule/enums/ErknmPlanStatusTitlesEnum';

export const mapErknmPlanStatusByStatusTitle: Record<ErknmPlanStatusTitlesEnum, ErknmPlanStatusesEnum> = {
  [ErknmPlanStatusTitlesEnum.IN_PROCESS]: ErknmPlanStatusesEnum.IN_PROCESS,
  [ErknmPlanStatusTitlesEnum.UNDER_CONSIDERATION]: ErknmPlanStatusesEnum.UNDER_CONSIDERATION,
  [ErknmPlanStatusTitlesEnum.CONSIDERED]: ErknmPlanStatusesEnum.CONSIDERED,
  [ErknmPlanStatusTitlesEnum.APPROVED]: ErknmPlanStatusesEnum.APPROVED,
};
